import { SessionRescheduleModal } from '../../../../components/common/Modal/SesssionRescheduleModal';
import { SessionCancelModal } from '../../../../components/common/Modal/SessionCancelModal';
import { showSuccessToast } from '../../../../components/PluginsMenu/Toastr/Toastr';
import { IMAGES } from '../../../../components/Dashboard/Content';
import { Button, Card, Row, Col } from 'react-bootstrap';
import phone from '../../../../../images/svg/phone.svg';
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';

export const AdminSessionDetails = () => {
    const [modalType, setModalType] = useState('');
    const [showModal, setShowModal] = useState(false);
    
    // Time-related state
    const sessionDateTime = dayjs("2025-02-25T15:00:00");
    const sessionEndDateTime = dayjs("2025-02-25T16:30:00");
    
    // Removed unused state and variables
    const [newSessionDate, setNewSessionDate] = useState('');
    const [newSessionStartTime, setNewSessionStartTime] = useState('');
    const [newSessionEndTime, setNewSessionEndTime] = useState('');
    
    const [errors, setErrors] = useState({
        date: '',
        startTime: '',
        endTime: ''
    });

    // Reset form errors when modal closes
    useEffect(() => {
        if (!showModal) {
            setErrors({
                date: '',
                startTime: '',
                endTime: ''
            });
        }
    }, [showModal]);

    const handleReschedule = () => {
        // Initialize with current session date and time
        setNewSessionDate(sessionDateTime.format('YYYY-MM-DD'));
        setNewSessionStartTime(sessionDateTime.format('HH:mm'));
        setNewSessionEndTime(sessionEndDateTime.format('HH:mm'));

        setModalType('reschedule');
        setShowModal(true);
    };

    const handleCancel = () => {
        setModalType('cancel');
        setShowModal(true);
    };

    const handleRescheduleSuccess = (startDateTime, duration) => {
        showSuccessToast(
            `Session successfully rescheduled to ${startDateTime.format(
                "MMMM D, YYYY [at] h:mm A"
            )} (${duration} minutes)`
        );
        setShowModal(false);
    };

    const handleCancelSuccess = () => {
        showSuccessToast("Session cancelled successfully!");
        setShowModal(false);
    };

    const handleCloseModal = () => setShowModal(false);

    const formattedSessionDate = sessionDateTime.format('MMM D, YYYY - h:mm A');
    const sessionDuration = '90 minutes';

    return (
        <>
            <div className="container-fluid py-5 pb-0">
                <Card className="shadow-lg rounded-lg">
                    <Card.Body>
                        {/* Session Header */}
                        <Row className="mb-4">
                            <Col className="d-flex align-items-center">
                                <div>
                                    <h4 className="text-dark font-weight-bold mb-2">Session with Ali (ali@nkenneapp.com)</h4>
                                    <span className="badge bg-primary text-white py-2 px-4 fs-5">Scheduled</span>
                                    <p className="text-muted mt-2">Discussing project progress, upcoming milestones, and action items for the next phase. Ensure to prepare any documents or questions in advance.</p>
                                </div>
                            </Col>
                        </Row>

                        {/* Session Details */}
                        <Row className="g-4">
                            {/* User Info */}
                            <Col xs={12} md={3}>
                                <h6 className="text-muted mb-2">User</h6>
                                <div className="d-flex align-items-center">
                                    <img src={IMAGES.trans2} alt="" className="avatar avatar-xl me-2" />
                                    <a href="#" className="text-primary">Ali Nkenne</a>
                                </div>
                            </Col>

                            {/* Tutor Info */}
                            <Col xs={12} md={3}>
                                <h6 className="text-muted mb-2">Tutor</h6>
                                <div className="d-flex align-items-center">
                                    <img src={IMAGES.trans2} alt="" className="avatar avatar-xl me-2" />
                                    <a href="#" className="text-primary">John Doe</a>
                                </div>
                            </Col>

                            {/* Scheduled Time */}
                            <Col xs={12} md={3}>
                                <h6 className="text-muted mb-2">Scheduled Time</h6>
                                <div><i className="fa fa-calendar text-success me-2"></i>{formattedSessionDate}</div>
                            </Col>

                            {/* Session Duration */}
                            <Col xs={12} md={3}>
                                <h6 className="text-muted mb-2">Session Duration</h6>
                                <div className="d-flex align-items-center">
                                    <img src={phone} alt="Duration" className="me-2" />
                                    <span>{sessionDuration}</span>
                                </div>
                            </Col>
                        </Row>

                        {/* Session Notes and Agenda */}
                        <Row className="g-4 mt-4">
                            <Col xs={12} md={6}>
                                <h6 className="text-muted mb-2">Session Notes</h6>
                                <p className="text-muted">Notes from previous session: Ali made significant progress on the project and has a few questions about the upcoming milestones.</p>
                                <p className="text-muted">Reminder: Bring updated project documents and questions about phase 2 to the session.</p>
                            </Col>

                            <Col xs={12} md={6}>
                                <h6 className="text-muted mb-2">Agenda</h6>
                                <ul className="text-muted">
                                    <li>Review project progress</li>
                                    <li>Discuss milestones for phase 2</li>
                                    <li>Clarify any issues or roadblocks</li>
                                    <li>Set action items for next steps</li>
                                </ul>
                            </Col>
                        </Row>

                        {/* Action Buttons */}
                        <Row className="mt-5">
                            <Col>
                                <div className="d-flex flex-column flex-md-row justify-content-start">
                                    <Button variant="warning" className="btn-md me-md-3 mb-3 mb-md-0" onClick={handleReschedule}>Reschedule Session</Button>
                                    <Button variant="danger" className="btn-md" onClick={handleCancel}>Cancel Session</Button>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </div>

            {modalType === "reschedule" && (
                <SessionRescheduleModal
                    show={showModal}
                    handleClose={handleCloseModal}
                    onSuccess={handleRescheduleSuccess}
                    initialDate={sessionDateTime.format("YYYY-MM-DD")}
                    initialStartTime={sessionDateTime.format("HH:mm")}
                    initialEndTime={sessionEndDateTime.format("HH:mm")}
                />
            )}

            {modalType === "cancel" && (
                <SessionCancelModal
                    show={showModal}
                    handleClose={handleCloseModal}
                    onSuccess={handleCancelSuccess}
                />
            )}
        </>
    );
};